import { Table } from "react-bootstrap";
import SpinnerBlock from "../others/SpinnerBlock";
import TableHeadTdOrder from "../others/TableHeadTdOrder";
import { useTranslation } from "react-i18next";
import { useWarehouse } from "./context/WarehouseProvider";
import WarehouseTableBody from "./WarehouseTableBody";
import { useAuth } from "context/AuthContext";
import vconst from "utils/helpers/structs/vconst";

const WarehouseTable = ({wId, stocksList, setShowTransfer, setShowComing, setShowPaymentsId, setShowPaymentsTitle, onlyView = false}: any) => {

    const { t } = useTranslation(['Warehouses']);
    const { auth } = useAuth();
    const { showSpinner,
            stocksOrder, setStocksOrder,
            stocksDesc, setStocksDesc,
            showCredit } = useWarehouse();

    const showBalanceColumn =
        showCredit &&
        auth?.user?.access?.role === 'manager' &&
        wId === vconst.waherouseMainId;

    const handleOrderClick = (value: string, desc: boolean) => {
        setStocksOrder(value); 
        setStocksDesc(desc);
    }

    return (<>
        <SpinnerBlock 
            onlyBlur={true}
            show={showSpinner}/> 

        <div className="crm-table-wrap">
            <Table className="StockTable table-hover">
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">
                            <TableHeadTdOrder
                                title={t('fields.prodName')}
                                onClick={handleOrderClick}
                                value={stocksOrder}
                                desc={stocksDesc}
                                fieldName='prod_name'/>

                            </td>
                        <td className="head-article">
                            <TableHeadTdOrder
                                title={t('fields.article')}
                                onClick={handleOrderClick}
                                value={stocksOrder}
                                desc={stocksDesc}
                                fieldName='prod_article'/>    
                        </td>                    
                        <td className="head-count">
                            <TableHeadTdOrder 
                                title={t('fields.countEnd')}
                                onClick={handleOrderClick}
                                value={stocksOrder}
                                desc={stocksDesc}
                                className="cursor-pointer d-flex align-items-center justify-content-center"
                                fieldName='stock_count'/>    
                        </td>
                        {showBalanceColumn && (
                            <td className="head-balance">
                                <TableHeadTdOrder
                                    title={t('fields.balance')}
                                    onClick={handleOrderClick}
                                    value={stocksOrder}
                                    desc={stocksDesc}
                                    className="cursor-pointer d-flex align-items-center justify-content-end"
                                    fieldName='stock_balance'/>
                            </td>
                        )}
                        <td className="head-updated">
                            <TableHeadTdOrder
                                title={t('fields.updated')}
                                onClick={handleOrderClick}
                                value={stocksOrder}
                                desc={stocksDesc}
                                fieldName='stock_updated'/>    
                        </td>

                        {!onlyView && 
                        (<td className="head-action">
                            {t('fields.action')}
                        </td>)}
     
                    </tr>
                </thead> 

                <WarehouseTableBody
                    wId={wId}
                    onlyView={onlyView}
                    showBalanceColumn={showBalanceColumn}
                    setShowPaymentsId={setShowPaymentsId}
                    setShowPaymentsTitle={setShowPaymentsTitle}
                    setShowTransfer={setShowTransfer}
                    setShowComing={setShowComing}
                    stocksList={stocksList}/>

            </Table>
        </div>
        </>)
}

export default WarehouseTable;